import {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { Currency, EUR, getCurrencyByIsoCode } from './currency'

type CurrencyContext = readonly [Currency, Dispatch<SetStateAction<Currency>>]

const CurrencyContext = createContext<CurrencyContext | null>(null)

export function useCurrencyContext() {
  const currencyContext = useContext(CurrencyContext)

  if (!currencyContext) {
    throw new Error('useCurrencyContext must be used within a CurrencyContextProvider')
  }

  return currencyContext
}

type CurrencyContextProviderProps = PropsWithChildren<{
  defaultCurrency?: string | null
}>

export const CurrencyContextProvider = ({
  children,
  defaultCurrency,
}: CurrencyContextProviderProps) => {
  const { company } = useCurrentSession()

  // TODO: remove this stuff once we enabled the cycles management FF, the default value should only rely in the proper parameter
  const legalEntityCurrencySymbol =
    company.legalEntities.find((el) => el.main)?.currency ?? EUR.symbol

  const [currency, setCurrency] = useState(() => {
    const currencySymbol = defaultCurrency || legalEntityCurrencySymbol
    return getCurrencyByIsoCode(currencySymbol)
  })

  const value = [currency, setCurrency] as const

  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>
}
